export default "__VITE_ASSET__3$_wZrk3__"